(() => {
  const init = () => {
    document.querySelectorAll('[data-ft-form-protection]').forEach((root) => {
      if (root.dataset.ftReady === 'true') return;
      root.dataset.ftReady = 'true';

      const form = root.closest('form');
      if (!form) return;

      const startedAt = Date.now();
      const minSeconds = Number(root.dataset.minSubmitSeconds || 4);
      const honeypot = root.querySelector('[data-ft-honeypot]');
      const browserCheck = root.querySelector('[data-ft-browser-check]');
      const submitAge = root.querySelector('[data-ft-submit-age]');
      const status = form.querySelector('[data-ft-form-protection-status]');
      const errorMessage = root.dataset.errorMessage || 'Please wait a moment and try again.';

      if (browserCheck) browserCheck.value = 'js-ready';

      form.addEventListener('submit', (event) => {
        const age = Math.max(0, Math.floor((Date.now() - startedAt) / 1000));
        if (submitAge) submitAge.value = String(age);

        const trapValue = honeypot ? honeypot.value.trim() : '';
        if (trapValue || age < minSeconds) {
          event.preventDefault();
          event.stopImmediatePropagation();
          if (status) {
            status.textContent = errorMessage;
            status.hidden = false;
          }
        }
      }, true);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
